import { WarningOutlined } from "@ant-design/icons";
import { useEffect } from "preact/hooks";

export interface PublishWarningBannerProps {
  showBanner: boolean;
  showPublishChanges: boolean;
  showPublishChangesDSA: boolean;
  onShow: () => void;
  onClose: () => void;
}

export default function PublishWarningBanner({ showBanner, showPublishChanges, showPublishChangesDSA, onShow, onClose }: PublishWarningBannerProps) {

  useEffect(() => {
    if (showPublishChanges) {
      onShow();
    }
  }, [showPublishChanges])

  useEffect(() => {
    if (showPublishChangesDSA) {
      onShow();
    }
  }, [showPublishChangesDSA])

  return showBanner ? <div className="publish-warning-banner">
      <div className="banner-content">
        <div className={'banner-text'}>
          <WarningOutlined style={{color: 'white'}}/>
          <span>Further edits will require a new Publish to update your channels.</span>
        </div>
        <button className="btn secondary7" onClick={() => onClose()}>Edit Design</button>
      </div>
    </div> : <></>;
}
